<template>

  <div>
  <el-dialog title="修改" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" ref="form" :model="form">
     <el-form-item label="排行耪名称" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="name">
         <el-input v-model="form.name"  placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="排行榜图片" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="image_url">
          <el-row>
            <el-button icon="el-icon-upload" @click="openUpload">选择图片</el-button>
            <div v-if="form.image_id > 0" class="img mt10"><img :src="form.image_url" width="100" height="100" /></div>
          </el-row>
          <div class="gray">图片为2M以内大小，格式限png，jpg格式
          <span>建议尺寸：750x360；</span>
          </div>
      </el-form-item>
      <el-form-item label="数据源" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="source_id">
        <el-input v-if="form.source_id>0" v-model="form.source.name" disabled class="max-w460"></el-input>
        <el-button type="primary"  @click="selectLink()">选择数据源</el-button>
        <div >数据源说明（不需要操作，专业技术人员添加调整）</div>
      </el-form-item>
       <el-form-item label="排行属性" :label-width="formLabelWidth"  >
         <el-input v-model="form.setting.ranking_name"  placeholder="" class="max-w460"></el-input>
         <div >示例：产品名称 给产品做排行（不需要操作，专业技术人员添加调整）</div>
      </el-form-item>
      <el-form-item label="排行内容" :label-width="formLabelWidth" >
         <el-input v-model="form.setting.ranking_value"  placeholder="" class="max-w460"></el-input>
         <div >示例：销售数量/件 根据销量排行（不需要操作，专业技术人员添加调整）</div>
      </el-form-item>
      <el-form-item label="每页显示数量" :label-width="formLabelWidth" >
         <el-input v-model="form.setting.list_rows"  placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="排序" :label-width="formLabelWidth">
         <el-input v-model="form.sort"  placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="是否开启：" :label-width="formLabelWidth">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible(false)">取 消</el-button>
      <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
   <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    <Source :issource="issource" @closeDialog="closeDialogFunc"></Source>
  </div>
</template>

<script>
  import RankingApi from '@/api/ranking.js';
  import Upload from '@/components/file/Upload';
  import Source from '@/components/ranking/Source';
  export default {
    components: {
      Source,
      Upload
    },
    data() {
      return {
        issource:false,
        /*是否上传图片*/
        isupload: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        /*form表单数据*/
        user:{},
      };
    },
    props: ['open_edit','form'],
    created() {
       this.dialogVisible = this.open_edit;
    },
    methods: {
        /*上传*/
      openUpload(e) {
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.form.image_url = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }
        this.isupload = false;
      },
      /*修改用户*/
      editUser() {
        let self = this;

        let params = self.form;
        console.log(params)
         self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
              RankingApi.Edit(params, true)
                .then(data => {
                  self.loading = false;
                  if (data.code == 1) {
                    self.$message({
                      message: '恭喜你，操作成功',
                      type: 'success'
                    });
                    self.dialogFormVisible(true);
                  }
                })
                .catch(error => {
                  self.loading = false;
                });
          }
        });
        
      },
      showMessage(msg='信息不能为空'){
        this.$message({
            message: msg,
            type: 'warning'
          });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        console.log(e)
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*打开用户弹窗*/
      openUserDialog() {
        this.open_user = true;
      },
      /*关闭用户弹窗*/
      closeUserDialog(e) {
        if (e.type != 'error') {
          this.user = e.params[0];
          console.log(e.params[0])
          this.form.user_id = e.params[0].user_id;
        }
        this.open_user = false;
      },
      closeDialogFunc(e) {
          console.log(e)
          let self = this;
          self.issource = false;
          if (e.type == 'success') {
            var source = {
              name:e.params[0].name,
              source_id:e.params[0].source_id,
            }
            self.form.source = source
            self.form.source_id = source.source_id
          }
      },
      /*打开添加*/
      selectLink() {
        this.issource = true;
      },


    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/ranking/index/dialog/Edit.vue